export default {
  computed: {
    // 判断浏览器是否支持 PWA 安装 API
    isPwaSupported() {
      // 检查Service Worker支持
      if (!('serviceWorker' in navigator)) {
        return false;
      }

      // 检查Promise支持（Service Worker需要）
      if (!window.Promise) {
        return false;
      }

      // 检查Fetch API支持
      if (!('fetch' in window)) {
        return false;
      }

      // 检查Cache API支持
      if (!('caches' in window)) {
        return false;
      }

      // 检查Manifest相关API
      if (!('onbeforeinstallprompt' in window)) {
        return false;
      }

      return true;
    },
    /**
     * 以独立窗口/主屏幕 App 打开（Safari 程序坞、iOS 主屏幕、PWA）。
     * 普通浏览器标签为 display-mode: browser，不命中。
     */
    isStandaloneLaunch() {
      try {
        if (window.navigator && window.navigator.standalone) {
          return true;
        }
        // 不用 minimal-ui：本页 manifest 就是 minimal-ui，普通标签也可能误判成桌面入口
        return ['standalone', 'fullscreen'].some(
          mode => window.matchMedia(`(display-mode: ${mode})`).matches
        );
      } catch (e) {
        return false;
      }
    }
  },
  methods: {
    shouldShowPwaTips() {
      if (window.deferredPrompt) {
        return false;
      }
      return true;
    }
  }
};
